var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4504 10.687L2.73511 10.3623L4.49275 1.10823C4.5704 0.698814 4.9304 0.402344 5.34687 0.402344H8.22687V2.14587H6.06687L4.44334 10.687H4.4504Z",
    fill: "#00B9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3868 10.687L17.7633 2.14587H15.6033V0.402344H18.4833C18.8997 0.402344 19.2597 0.698814 19.3374 1.10823L21.095 10.3623L19.3797 10.687H19.3868Z",
    fill: "#00B9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6103 0H8.22681V2.82353H15.6103V0Z",
    fill: "#2222B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9773 9.60706H1.85969C0.716165 9.60706 -0.159129 10.6376 0.0244002 11.76L1.76793 22.4471C1.91616 23.3435 2.68558 24 3.59616 24H20.2338C21.1444 24 21.9138 23.3435 22.062 22.4471L23.8056 11.76C23.9891 10.6306 23.1209 9.60706 21.9773 9.60706Z",
    fill: "#2222B3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.c0d29b9b5da0266c8caa008221b70b3a.svg";
export { ForwardRef as ReactComponent };